import { render } from "./customer-portal-app.vue?vue&type=template&id=0de23728&lang=pug"
import script from "./customer-portal-app.vue?vue&type=script&lang=js"
export * from "./customer-portal-app.vue?vue&type=script&lang=js"

import "./customer-portal-app.vue?vue&type=style&index=0&id=0de23728&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__